import EmptyLayout from "@/layouts/EmptyLayout.vue"; // Import EmptyLayout
import LoginPage from "../views/LoginPage.vue";
import RegisterInvitePage from "../views/RegisterInvitePage.vue";
import RegisterPage from "../views/RegisterPage.vue";
import ForgotPasswordPage from "@/views/ForgotPasswordPage.vue";
import VerifyEmailPage from "@/views/VerifyEmailPage.vue";
import EmailVerificationPage from "@/views/EmailVerificationPage.vue";
import ResetPasswordPage from "@/views/ResetPasswordPage.vue";
import cookiesService from "@/services/cookiesService";

import { getSafeAuthRedirect } from "@/utils/authRedirect";
import {
  getGoogleLoginAttempt,
  notifyGoogleLoginSuccess,
} from "@/services/googleLoginService";

const authRoutes = [
  {
    path: "/auth/google",
    name: "GoogleAuth",
    component: EmptyLayout,
    beforeEnter: async (to) => {
      const token = to.query.token;
      const isMergedAccount = Boolean(to.query.isMergedAccount);
      const attempt = getGoogleLoginAttempt();

      // Scrub credentials before writing storage or making any asynchronous calls.
      const url = new URL(window.location.href);
      url.searchParams.delete("token");
      window.history.replaceState({}, "", url);

      if (typeof token !== "string" || !token.trim()) {
        return { path: "/" };
      }

      try {
        // Keep the existing API token/cookie contract.
        await cookiesService.setCookie("authToken", { token });

        let previousRedirect;
        try {
          previousRedirect = localStorage.getItem("postLoginRedirect");
          localStorage.removeItem("postLoginRedirect");
          localStorage.removeItem("googleLoginSuccess");
        } catch {
          // A restricted storage policy must not prevent a full-page login.
        }
        let redirectTo = getSafeAuthRedirect(
          attempt?.redirectTo || previousRedirect
        );
        if (isMergedAccount) {
          const destination = new URL(redirectTo, window.location.origin);
          destination.searchParams.set("isMergedAccount", "true");
          redirectTo = getSafeAuthRedirect(destination.href);
        }

        if (attempt?.usePopupMode) {
          notifyGoogleLoginSuccess(attempt, redirectTo, isMergedAccount);
          window.close();
          return;
        }

        try {
          sessionStorage.removeItem("googleLoginAttempt");
        } catch {
          // The attempt also expires automatically.
        }
        window.location.href = redirectTo;
      } catch {
        console.error("Failed to complete Google login.");
        return { path: "/" };
      }
    },
  },
  {
    path: "/login",
    component: EmptyLayout,
    children: [
      {
        path: "",
        name: "LoginPage",
        component: LoginPage,
        meta: {
          requiresAuth: false,
          title: "Login",
          redirectIfAuthenticated: true,
        },
      },
      {
        path: "/verify-account",
        name: "RegisterInvitePage",
        component: RegisterInvitePage,
        meta: {
          requiresAuth: false,
          title: "Register Invite Page",
          redirectIfAuthenticated: true,
        },
      },
    ],
  },
  {
    path: "/signup",
    component: EmptyLayout,
    children: [
      {
        path: "",
        name: "RegisterPage",
        component: RegisterPage,
        meta: {
          requiresAuth: false,
          title: "Register",
          redirectIfAuthenticated: true,
        },
      },
    ],
  },
  {
    path: "/forgot-password",
    component: EmptyLayout,
    children: [
      {
        path: "",
        name: "ForgotPasswordPage",
        component: ForgotPasswordPage,
        meta: {
          requiresAuth: false,
          title: "Forgot Password",
          redirectIfAuthenticated: true,
        },
      },
    ],
  },
  {
    path: "/verification",
    component: EmptyLayout,
    children: [
      {
        path: "",
        name: "VerifyEmailPage",
        component: VerifyEmailPage,
        meta: {
          requiresAuth: false,
          title: "Verify Email",
          redirectIfAuthenticated: true,
        },
      },
    ],
  },
  {
    path: "/email-verification",
    component: EmptyLayout,
    children: [
      {
        path: "",
        name: "EmailVerificationPage",
        component: EmailVerificationPage,
        meta: {
          requiresAuth: false,
          title: "Email Verification",
          redirectIfAuthenticated: true,
        },
      },
    ],
  },
  {
    path: "/reset-password",
    component: EmptyLayout,
    children: [
      {
        path: "",
        name: "ResetPasswordPage",
        component: ResetPasswordPage,
        meta: {
          requiresAuth: false,
          title: "Reset Password",
          redirectIfAuthenticated: true,
        },
      },
    ],
  },
];

export default authRoutes;
